import { render, staticRenderFns } from "./indexHomepage_new.vue?vue&type=template&id=0ec54441&scoped=true"
import script from "./indexHomepage_new.vue?vue&type=script&lang=js"
export * from "./indexHomepage_new.vue?vue&type=script&lang=js"
import style0 from "./indexHomepage_new.vue?vue&type=style&index=0&id=0ec54441&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec54441",
  null
  
)

export default component.exports